import { BlogPost } from '../types/blog';

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Building Better Habits: A Comprehensive Guide',
    urlFriendlyName: 'building-better-habits-guide',
    excerpt: 'Learn the science-backed strategies for creating lasting habits and breaking bad ones.',
    author: 'Streak Spark Team',
    publishedDate: '2024-01-15',
    tags: ['habits', 'productivity', 'psychology'],
    featuredImage: '/assets/4-profile-darkmode.png',
    content: [
      {
        type: 'paragraph',
        content: 'Habits are the building blocks of our daily lives. Whether we realize it or not, our routines shape who we are and what we achieve. In this comprehensive guide, we\'ll explore the science of habit formation and provide practical strategies for building better habits.'
      },
      {
        type: 'heading',
        level: 2,
        content: 'The Science of Habit Formation'
      },
      {
        type: 'paragraph',
        content: 'Research shows that habits follow a three-step loop: cue, routine, and reward. Understanding this loop is crucial for both creating new habits and breaking old ones.'
      },
      {
        type: 'image',
        src: '/assets/8-home-page.png',
        alt: 'Habit formation loop diagram'
      },
      {
        type: 'heading',
        level: 2,
        content: 'Practical Strategies for Success'
      },
      {
        type: 'list',
        items: [
          'Start small with micro-habits that take less than 2 minutes',
          'Use habit stacking to attach new habits to existing routines',
          'Track your progress consistently',
          'Be patient and kind to yourself during setbacks'
        ]
      },
      {
        type: 'paragraph',
        content: 'Remember, building better habits is a journey, not a destination. Every small step counts towards creating the life you want.'
      },
      {
        type: 'video',
        url: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
        alt: 'Motivational video about habit building'
      },
      {
        type: 'link',
        text: 'Learn more about habit tracking with Streak Spark',
        href: '/guide'
      }
    ]
  },
  {
    id: '2',
    title: 'The Power of Daily Streaks',
    urlFriendlyName: 'power-of-daily-streaks',
    excerpt: 'Discover how maintaining daily streaks can transform your productivity and motivation.',
    author: 'Streak Spark Team',
    publishedDate: '2024-02-01',
    tags: ['streaks', 'motivation', 'consistency'],
    content: [
      {
        type: 'paragraph',
        content: 'Daily streaks are more than just numbers on a calendar. They represent commitment, consistency, and the power of compound effort. In this post, we explore why streaks work and how to maintain them effectively.'
      },
      {
        type: 'heading',
        level: 2,
        content: 'Why Streaks Matter'
      },
      {
        type: 'paragraph',
        content: 'Streaks create momentum. Each day you maintain your streak, you\'re not just completing a task—you\'re reinforcing your identity as someone who follows through on their commitments.'
      },
      {
        type: 'image',
        src: '/assets/13-app-day-view-with-bingo.png',
        alt: 'Calendar showing a long streak'
      },
      {
        type: 'paragraph',
        content: 'The psychological principle behind streaks is simple but powerful: we\'re motivated to avoid losing what we\'ve gained. This "loss aversion" keeps us coming back day after day.'
      }
    ]
  }
];

export const getBlogPostByUrlFriendlyName = (urlFriendlyName: string): BlogPost | undefined => {
  return blogPosts.find(post => post.urlFriendlyName === urlFriendlyName);
};
